﻿import controller from '../../../../resources/scripts/_shared/controller';
//import youtube from '../../../../resources/scripts/_shared/youtube';

function videoBlock(context) {
  let videoContainer = context.querySelector('.videoblock__player');
  const playButton = context.querySelector('.videoblock__button');
  //const canvas = context.querySelector('.videoblock__canvas');
  //const image = context.querySelector('.videoblock__image');
  const videoId = context.dataset.videoId;
  //const useDynamicColor = context.dataset.dynamicColor;

  function loadYouTubeScripts() {
    if (document.querySelector('script[src*="youtube.com/iframe_api"]')) {
      onYouTubeIframeAPIReady();
      return;
    }

    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function onYouTubeIframeAPIReady() {
    if (window.aimoVideoQue.length === 0 || !window.YT)
      return;
    setTimeout(() => {
      window.aimoVideoQue.forEach((video) => {
        if (video.playerInstance)
          return;
        const player = new YT.Player(video.videoContainer, {
          videoId: video.videoId,
          host: 'https://www.youtube-nocookie.com',
          events: {
            'onStateChange': onPlayerStateChange,
          },
          playerVars: {
            rel: 0,
            origin: window.location.host,
            //playlist: video.videoId,
            //loop: 1
          }
        });
        video.playerInstance = player;
      });
    }, 1000)
  }

  function addVideoToQue(video) {
    window.aimoVideoQue = window.aimoVideoQue || [];
    let videoCount = window.aimoVideoQue.length;

    window.aimoVideoQue.push(video);

    if(window.aimoVideoQue.length > videoCount)
      return true;

    return false;
  }

  function getPlayerByVideoId(id) {
    const blockObject = window.aimoVideoQue.find(video => video.videoId === id);
    if (blockObject)
      return blockObject.playerInstance;

    return null;
  }

  function onPlayerStateChange(event) {
    const id = event.target.playerInfo.videoData.video_id;
    const blockObject = window.aimoVideoQue.find(video => video.videoId === id);
    const videoBlockContext = blockObject.videoContext;

    var done = false;
    if (event.data === YT.PlayerState.PLAYING && !done) {
      videoBlockContext.classList.add('videoblock--loading-done');
      videoBlockContext.querySelector('iframe').classList.remove('videoblock__player--hide');
      done = true;
    }
  }

	function setDominantColorClass() {
    const ctx = canvas.getContext('2d');

    image.addEventListener('load', e => {
      ctx.drawImage(image, 0, 0, 1, 1);

      const canvasData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      const newColorClass = (canvasData[0] * 0.299 + canvasData[1] * 0.587 + canvasData[2] * 0.114) > 186 ? 'videoblock--dark' : null;

      if (newColorClass)
        context.classList.add(newColorClass);
    });
	}

  function init() {
    addVideoToQue({
      videoId,
      videoContainer,
      videoContext: context,
      playerInstance: null,
    });

    loadYouTubeScripts();

    //if(useDynamicColor)
    //  setDominantColorClass();

    const ua = navigator.userAgent;

    if (/(iPhone|iPod|iPad)/i.test(ua)) {
      setTimeout(() => {
        const videoIframe = document.querySelector('iframe');

        videoIframe.classList.remove('videoblock__player--hide');
        videoIframe.classList.add('videoblock__player--transparent');

        const iosWorkAround = () => {
          const videoIframe = document.querySelector('iframe');
          if (document.activeElement != videoIframe) return;
          context.classList.add('videoblock--loading', 'videoblock--videopadding');
          setTimeout(() => {
            context.classList.add('videoblock--loading-done');
            videoIframe.classList.remove('videoblock__player--transparent');
          }, 1000);
          window.removeEventListener("blur", iosWorkAround);
        }

        window.addEventListener("blur", iosWorkAround);
      }, 1500);
      return;
    }

    playButton.addEventListener('click', function (event) {
      event.preventDefault();
      const player = getPlayerByVideoId(videoId);
      if (player) {
        context.classList.add('videoblock--loading', 'videoblock--videopadding');
        player.playVideo();
      }
    });
  }

  return {
    init
  };
}

controller.add('video-block', videoBlock);